import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import RecipeButton from "./RecipeButton";
import { useCheckoutStore } from "../../store/useCheckoutStore";
import { getConfectioneryDetail } from "../../utils/confectioneryManager";

export default function Recipe({
  recipe,
  principalProduct,
  recipeProducts,
  onSelectRecipeProducts,
}) {
  const { confectioneries_api } = useCheckoutStore();

  const onSelectProduct = (product, index = null) => {
    if (!recipe.Receta) {
      return;
    }
    const firstProduct = recipe.Receta[0];
    if (recipe.Tipo === "P") {
      onSelectRecipeProducts(product);
    } else {
      const isAdded = recipeProducts.find(
        (item) => item.Codigo === recipe.Codigo
      );
      const products = isAdded ? isAdded.Receta : [];
      let removeSelection = products.length ? products[index || 0] : false;
      removeSelection = removeSelection
        ? removeSelection.Codigo === product.Codigo
        : false;
      const data = {
        Codigo: recipe.Codigo,
        Descripcion: recipe.Descripcion,
        Tipo: recipe.Tipo,
      };
      products[index || 0] = removeSelection ? firstProduct : product;
      data.Receta = products;
      if (recipe.Cantidad) {
        data.Cantidad = recipe.Cantidad;
      }
      onSelectRecipeProducts(data);
    }
  };

  const renderProducts = (products, index) => {
    return products.map((product, productIndex) => {
      const recipeSelected = recipeProducts.find(
        (item) => item.Codigo === recipe.Codigo
      );
      const productApi = getConfectioneryDetail(
        product.Codigo,
        confectioneries_api
      );
      let selected = "";
      if (recipeSelected && recipeSelected.Receta[index]) {
        if (recipeSelected.Tipo === "P") {
          selected = "selected";
        } else {
          if (recipeSelected.Receta[index]) selected = "opacity";
          if (recipeSelected.Receta[index].Codigo === product.Codigo)
            selected = "selected";
        }
      }
      return (
        <RecipeButton
          product={product}
          key={product.Codigo}
          onSelectProduct={onSelectProduct}
          index={index}
          productIndex={productIndex}
          selected={selected}
          productApi={productApi}
        />
      );
    });
  };

  const renderRows = () => {
    const rows = [];
    for (let i = 0; i < recipe.Cantidad; i++) {
      if (recipe.Tipo === "A") {
        if (principalProduct) {
          rows.push(
            <Box
              key={i}
              sx={{
                p: 1,
                backgroundColor: i % 2 === 1 ? "grey.100" : "transparent",
              }}
            >
              {recipe.Cantidad > 1 && (
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: 500,
                    borderBottom: 1,
                    borderColor: "error.main",
                    mb: 1,
                  }}
                >
                  a{principalProduct?.category_name.toUpperCase()} {i + 1}
                </Typography>
              )}
              <Box>{renderProducts(recipe.Receta, i)}</Box>
            </Box>
          );
        }
      }
      if (recipe.Tipo === "P") {
        const recipeSelected = recipeProducts.find(
          (item) => item.Codigo === recipe.Codigo
        );
        const productApi = getConfectioneryDetail(
          recipe.Codigo,
          confectioneries_api
        );
        rows.push(
          <Box
            key={i}
            sx={{
              p: 1,
              backgroundColor: i % 2 === 1 ? "grey.100" : "transparent",
            }}
          >
            <RecipeButton
              product={recipe}
              onSelectProduct={onSelectProduct}
              selected={recipeSelected ? "selected" : ""}
              productIndex={0}
              productApi={productApi}
            />
          </Box>
        );
      }
    }
    return rows;
  };

  let recipeApi = {};
  if (recipe?.Receta) {
    recipeApi = getConfectioneryDetail(
      recipe?.Receta[0].Codigo,
      confectioneries_api
    );
  } else {
    recipeApi = getConfectioneryDetail(recipe?.Codigo, confectioneries_api);
  }

  return (
    <Box sx={{ p: "0 10px", mb: 2 }}>
      {principalProduct.category_id === 1 ? (
        <Box sx={{ mb: 2, pb: 1, borderBottom: 2, borderColor: "white" }}>
          <Typography
            variant="body1"
            sx={{
              fontFamily: "var(--bold)",
            }}
          >
            {recipe.name}
          </Typography>
        </Box>
      ) : (
        <Box sx={{ mb: 2, pb: 1, borderBottom: 2, borderColor: "white" }}>
          <Typography variant="body1" sx={{ fontFamily: "var(--bold)" }}>
            {recipe.Cantidad > 1 ? (
              <span>{recipeApi?.category_name.toUpperCase()}S</span>
            ) : (
              <span>{recipeApi?.category_name}</span>
            )}
          </Typography>
        </Box>
      )}
      <Box>{renderRows()}</Box>
    </Box>
  );
}

Recipe.propTypes = {
  recipe: PropTypes.object,
  principalProduct: PropTypes.object,
  recipeProducts: PropTypes.array,
  productApi: PropTypes.object,
  onSelectRecipeProducts: PropTypes.func,
};
